export default __webpack_public_path__ + "static/media/menu.97c178ce.svg";